import React, { FunctionComponent } from 'react'
import Svg, { Path } from 'react-native-svg'

import { useTheme } from 'styled-components/native'

import { AuroraThemeType } from '../../utils/themes/ThemeProvider'

type Props = {
  size?: number | string
}

export const AuroraIndividualTherapySecondaryRecIllustration: FunctionComponent<Props> = ({ size = 64 }) => {
  const { colors } = useTheme() as AuroraThemeType
  const { spotIllustration } = colors.icons

  return (
    <Svg width={size} height={size} viewBox='0 0 64 64' fill='none'>
      <Path
        d='M39.0633 45.7381C32.7358 56.4057 17.514 54.4031 8 52.4331C9.85291 51.9957 12.0478 51.2247 12.4118 49.3772C12.6409 48.2107 12.0149 47.0737 11.5474 45.9785C6.1518 33.3688 20.0745 27.5611 30.3824 30.7721C39.0617 33.4743 42.3282 40.236 39.0633 45.7396V45.7381Z'
        fill={spotIllustration.secondary.fill}
      />
      <Path
        d='M24.5022 30.8621C33.74 38.7376 47.5608 31.6951 56 25.0901C46.0781 26.0875 51.4564 16.2157 39.8102 11.3123C25.2317 5.17421 14.1958 22.0761 24.5022 30.8621Z'
        fill={spotIllustration.primary.fill}
      />
    </Svg>
  )
}
